module.exports = __webpack_public_path__ + "img/type2.20c9ef49.gif";